pure virtual task wait_for_num_clocks(int num_clocks=1);
{{#if interface.hasResetAndOtherPorts}}
pure virtual task wait_for_reset();
pure virtual task wait_for_reset_to_deassert();
{{/if}}
